import { Site } from '@envato/foundation-types'
import omit from 'lodash-es/omit'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import {
  ILocationParams,
  IQuery
} from '../../../common/reducers/reactRouterLocation'
import { dearrayParamValues } from '../../../common/utils/location/format'
import BasicForm from '../basicForm'

interface IProps extends React.FormHTMLAttributes<HTMLFormElement> {
  locationParams?: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const nextQuery = (
  locationParams: ILocationParams,
  query: IQuery
): ILocationParams => {
  // only update query inside the from and keep the existing one
  const newQuery = { ...locationParams, ...query }
  // remove page param when do search
  delete newQuery.page
  return dearrayParamValues(newQuery)
}

const SearchBarFormPure = (props: IProps & RouteComponentProps<any>) => {
  const { locationParams = {}, makeSearchLink, history, children } = props
  const passProps = omit(props, [
    'locationParams',
    'makeSearchLink',
    'router',
    'onSubmit',
    'role',
    'method',
    'action',
    'match',
    'history',
    'staticContext',
    'nextQuery',
    'location'
  ])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    // get query from form
    const form = event.currentTarget
    const query: { [propName: string]: string } = {}
    Array.prototype.slice
      .call(form.elements)
      .filter((el: HTMLInputElement) => el.getAttribute('name') && el.value)
      .forEach((el: HTMLInputElement) => {
        query[el.getAttribute('name') as string] = el.value
      })

    history.push(makeSearchLink(nextQuery(locationParams, query)))
  }

  return (
    <BasicForm
      role="search"
      method="get"
      action="/search"
      onSubmit={onSubmit}
      {...passProps}
    >
      {children}
    </BasicForm>
  )
}

export default withRouter(SearchBarFormPure)
